import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutAction } from "../store/authActions";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logoutAction()).then((response) => {
      const { type } = response;
      if (type === "auth/logout/fulfilled") {
        window.location.href = "/";
      }
    });
  }, []);

  return <></>;
};

export default Logout;
